import { FileType } from '@Components/FileUploadDropzone/FileTypes';
import IWorkflowTransition from '@Services/workflow/IWorkflowTransition';
import WorkflowEngine from '@Services/workflow/WorkflowEngine';

export const UploadFileWorkflowState = {
    PENDING: 'pending',
    SUBMITTING_HEADERS: 'submittingHeaders',
    SELECTING_HEADERS: 'selectingHeaders',
    CREATING_FOLDER: 'creatingFolder',
    UPLOADING_SINGLE_FILE: 'uploadingSingleFile',
    UPLOADING_MULTIPLE_FILE: 'uploadingMultipleFile',
    COMPLETED: 'completed',
};

export enum UploadFileWorkflowAction {
    SELECTED_FILES,
    SELECTED_FILES_ERROR,
    SUBMITTED_HEADERS,
    SELECTED_HEADERS,
    CREATED_FOLDER,
    UPLOADED_FILE,
}

const createFileUploadWorkflow = (initialState: string): WorkflowEngine => {
    const properties = {
        initialState: initialState,
        transitions: [
            ...pendingTransitions,
            ...selectingHeadersTransitions,
            ...creatingFolderTransitions,
            ...uploadingTransitions,
        ],
        methods: {},
    };
    return new WorkflowEngine(properties);
};

export default createFileUploadWorkflow;

const pendingTransitions: Array<IWorkflowTransition> = [
    {
        currentState: UploadFileWorkflowState.PENDING,
        action: UploadFileWorkflowAction.SELECTED_FILES,
        newState: (fileType: FileType) => {
            switch (fileType) {
                case FileType.CSV:
                    return UploadFileWorkflowState.SUBMITTING_HEADERS;
                case FileType.JPG:
                    return UploadFileWorkflowState.CREATING_FOLDER;
            }
        },
    },
    {
        currentState: UploadFileWorkflowState.PENDING,
        action: UploadFileWorkflowAction.SELECTED_FILES_ERROR,
        newState: UploadFileWorkflowState.PENDING,
    },
];

const selectingHeadersTransitions: Array<IWorkflowTransition> = [
    {
        currentState: UploadFileWorkflowState.SUBMITTING_HEADERS,
        action: UploadFileWorkflowAction.SUBMITTED_HEADERS,
        newState: UploadFileWorkflowState.SELECTING_HEADERS,
    },
    {
        currentState: UploadFileWorkflowState.SUBMITTING_HEADERS,
        action: UploadFileWorkflowAction.SELECTED_FILES_ERROR,
        newState: UploadFileWorkflowState.PENDING,
    },
    {
        currentState: UploadFileWorkflowState.SELECTING_HEADERS,
        action: UploadFileWorkflowAction.SELECTED_HEADERS,
        newState: UploadFileWorkflowState.UPLOADING_SINGLE_FILE,
    },
];

const creatingFolderTransitions: Array<IWorkflowTransition> = [
    {
        currentState: UploadFileWorkflowState.CREATING_FOLDER,
        action: UploadFileWorkflowAction.CREATED_FOLDER,
        newState: UploadFileWorkflowState.UPLOADING_MULTIPLE_FILE,
    },
    {
        currentState: UploadFileWorkflowState.CREATING_FOLDER,
        action: UploadFileWorkflowAction.SELECTED_FILES_ERROR,
        newState: UploadFileWorkflowState.PENDING,
    },
];

const uploadingTransitions: Array<IWorkflowTransition> = [
    {
        currentState: UploadFileWorkflowState.UPLOADING_MULTIPLE_FILE,
        action: UploadFileWorkflowAction.UPLOADED_FILE,
        newState: (remainingFiles: number) => {
            return remainingFiles === 0
                ? UploadFileWorkflowState.COMPLETED
                : UploadFileWorkflowState.UPLOADING_MULTIPLE_FILE;
        },
    },
    {
        currentState: UploadFileWorkflowState.UPLOADING_SINGLE_FILE,
        action: UploadFileWorkflowAction.UPLOADED_FILE,
        newState: UploadFileWorkflowState.COMPLETED,
    },
];
